module.exports = __webpack_public_path__ + "media/images/flags/me-cd3656ad63230e27a826fbe833e3ca16.svg";